import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../../image/Logo";
import closeIcon from "../../image/close.png";
import "./SideBar.css";
import people from "../../image/people_outline.png";
import dashboard from "../../image/dashboard_outline.png";
import addSymbol from "../../image/fitbitAdd2.png";
import person from "../../image/person2_outline.png";
import logout from "../../image/logout2_outline.png";

const SideBar = ({ toggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(location.pathname); // Keeps the active item even on refresh

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const sidebarNavItems = [
    {
      display: "Patient Dashboard",
      to: "/dashboard",
      icon: <img src={dashboard} alt="Patient Dashboard" className="icon" />,
    },
    {
      display: "All Patients",
      to: "/",
      icon: <img src={people} alt="All Patients" className="icon" />,
    },
    {
      display: "Add Fitbit",
      to: "/add_fitbit",
      icon: <img src={addSymbol} alt="Add Fitbit" className="icon" />,
    },
    {
      display: "Profile",
      to: "/profile",
      icon: <img src={person} alt="Profile" className="icon" />,
    },
    {
      display: "Logout",
      to: "/login",
      icon: <img src={logout} alt="Logout" className="icon" />,
      onClick: handleLogout,
    },
  ];

  return (
    <div className={`sidebar ${toggle ? "active_nav" : ""}`}>
      <div className="closeBtn">
        <img src={closeIcon} alt="close" />
      </div>
      <div className="sidebar__logo">
        <Link to="/home">
          <Logo />
          <p>ActivTrack RTM</p>
        </Link>
      </div>
      <ul className="sidebar__menu">
        {sidebarNavItems.map((item, index) => (
          <li key={index} className="sidebar__menu__item">
            <Link
              to={item.to}
              className={`sidebar__menu__button ${
                activeItem === item.to ? "active" : ""
              }`}
              onClick={() => {
                setActiveItem(item.to);
                if (item.onClick) item.onClick();
              }}
            >
              {item.icon}
              {item.display}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SideBar;
